import { ActivatedRouteSnapshot, RouterStateSnapshot,  Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';

@Injectable({
  providedIn:'root'
})

 
export class SuperAdminGuard {
    constructor(private route:Router, private localStorageService: LocalStorageService){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean  {
    let role = this.localStorageService.getRole();
    
      if(role !== 'SuperAdmin'){
        this.route.navigateByUrl('')
        return false
      }
      
      return true
  }
}
